/**
 * 全局配置文件（非敏感项可写在此；密钥见 .env.<mode> 或 public/runtime-config.js）
 */
import { stage } from './env'
import { pickBool, pickString } from './runtimeConfig'

const clientId = pickString('clientId', 'VUE_APP_CLIENT_ID', '')
const clientSecret = pickString('clientSecret', 'VUE_APP_CLIENT_SECRET', '')

if (process.env.NODE_ENV === 'development' && (!clientId || !clientSecret)) {
  // eslint-disable-next-line no-console
  console.warn(
    '[yzfc-datav] 未配置 OAuth：请 cp .env.example .env.development 并填写 VUE_APP_CLIENT_ID / VUE_APP_CLIENT_SECRET'
  )
}

export default {
  title: "YZFC数字养殖平台",
  forgetPassword: "手机号找回",
  logo: "Y",
  key: 'yzfc',
  indexTitle: 'YZFC数字养殖平台',
  clientId,
  clientSecret,
  cityName: '宁波',
  headerTitle: '原子方程海洋生物大数据AI训练基地',
  tenantMode: true,
  tenantId: "000000",
  captchaMode: true,
  lockPage: '/lock',
  tokenTime: 3000,
  pageSize: 20,
  uploadPictrueLimt: 9,
  uploadSize: 5,
  uploadFileLimt: 3,
  deptId: "1123598813738675202",
  tokenHeader: 'Blade-Auth',
  calcHeight: 50,
  statusWhiteList: [],
  isFirstPage: false,
  fistPage: {
    label: "首页",
    value: "/wel/index",
    params: {},
    query: {},
    meta: { i18n: 'dashboard' },
    group: [],
    close: false
  },
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  },
  authUrl: pickString('authUrl', 'VUE_APP_AUTH_URL', 'http://192.168.0.103/blade-auth/oauth/render'),
  flowDesignUrl: pickString('flowDesignUrl', 'VUE_APP_FLOW_DESIGN_URL', '8.136.99.229:9999'),
  reportUrl: pickString('reportUrl', 'VUE_APP_REPORT_URL', '8.136.99.229:8108/ureport'),
  echartType: {
    yy: 'line',
    ad: 'line',
    yl: 'line',
    ph: 'line',
    orp: 'line',
    hhs: 'line',
    hhx: 'line',
    lhs: 'line',
    lhx: 'line',
    tc: 'bar',
    tz: 'bar',
    zs: 'bar',
    dv: 'line',
    pv: 'line',
    tv: 'line',
    lv: 'line',
    day: 'bar',
    jd: 'bar'
  },
  cookieDomain: (() => {
    const v = pickString('cookieDomain', 'VUE_APP_COOKIE_DOMAIN', '')
    if (v !== '') return v
    return stage !== 'dev' ? '.yzfc.vip' : undefined
  })(),
  cookieExpires: Number(process.env.VUE_APP_COOKIE_EXPIRES) || 30,
  cookiePath: process.env.VUE_APP_COOKIE_PATH || '/',
  cookieSecure: pickBool('VUE_APP_COOKIE_SECURE', false),
  cookieSameSite: (() => {
    const v = process.env.VUE_APP_COOKIE_SAME_SITE
    if (v === '' || v === undefined) return undefined
    return v
  })()
}
